import { RoleTypeEnum } from '@cyberlabrs/helpers';

export const isAdminOrOwner = (roleName: RoleTypeEnum | undefined): boolean => {
    if (!roleName) return false;
    return [RoleTypeEnum.ADMIN, RoleTypeEnum.OWNER].includes(roleName);
};

export const isPrivileged = (roleName: RoleTypeEnum | undefined): boolean => {
    if (!roleName) return false;
    return [RoleTypeEnum.ADMIN, RoleTypeEnum.OWNER, RoleTypeEnum.PM].includes(roleName);
};

export const isNotPrivileged = (roleName: RoleTypeEnum | undefined): boolean => {
    return !isPrivileged(roleName);
};
